import {link} from "autolinker"

/**
 * Limit text by
 * @param {string} str
 * @param {number} limit
 */
export const limitBy = (str, limit) => `${str.substring(0, limit)}...`

/**
 * Formating the text as rtf
 * @param {string} text
 */
export const formatText = text => {
	if (text.includes("http://") || text.includes("https://")) {
		return link(text, {
			className: "isLink",
			truncate: {length: 32, location: "middle"}
		})
	}
	return text
}

/**
 * Fallback for copy to clipboard, older browsers before 2015
 * @param {string} text The text to copy
 * @return {void}
 */
const fallbackCopyTextToClipboard = async text => {
	const input = document.createElement("input")
	input.value = text

	// Avoid scrolling to bottom
	input.style.top = "0"
	input.style.left = "0"
	input.style.position = "fixed"

	document.body.appendChild(input)
	input.focus()
	input.select()

	if (document.body.createTextRange) {
		const range = document.body.createTextRange()
		range.moveToElementText(input)
		range.select()
	} else if (window.getSelection) {
		const selection = window.getSelection()
		const range = document.createRange()
		range.selectNodeContents(input)
		selection.removeAllRanges()
		selection.addRange(range)
	}

	const copyTask = await Promise.resolve(document.execCommand("copy"))

	document.body.removeChild(input)

    return copyTask;
}

/**
 * Copy text to clipboard
 * @param {string} text The text to copy
 * @return {void}
 */
export const copyToClipboard = async text => {
	if (!navigator.clipboard) {
		return fallbackCopyTextToClipboard(text)
	}

	return navigator.clipboard.writeText(text)
}
